// TODO: Only import used BootstrapVue components
// TODO: Break up index.js into multiple files
import 'core-js/fn/symbol';
import 'core-js/fn/promise';

import 'src/app/sass/style.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

import './app/modernizr';
import './app/index.js';



// WEBPACK FOOTER //
// ./src/index.js